import React, { useEffect, useState } from "react";
import Card from "components/card";
import { MdBadge, MdSearch } from "react-icons/md";
import { tokenManager } from "utils/tokenManager";

const API_AUDIT = "https://usibras-web-backend.onrender.com/api/shift-sms/audit-log";

const getDateString = (date) => date.toISOString().slice(0, 10);

const ShiftLogs = () => {
  const today = new Date();
  const [reportDate, setReportDate] = useState(getDateString(today));
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const getHeaders = () => {
    const auth = tokenManager.getAuthHeader();
    return { "Content-Type": "application/json", ...(auth ? { Authorization: auth } : {}) };
  };

  const fetchLogs = async (date) => {
    setLoading(true);
    setMessage("");
    try {
      const endpoint = `${API_AUDIT}?report_date=${encodeURIComponent(date)}`;
      const res = await fetch(endpoint, { headers: getHeaders() });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Failed to load audit log");
      setLogs(data.data || []);
    } catch (err) {
      setLogs([]);
      setMessage(err.message || "Could not load shift logs");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchLogs(reportDate); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="mt-5 h-full space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <MdBadge className="h-8 w-8 text-amber-500" />
          <h2 className="text-2xl font-bold text-navy-700 dark:text-white">Shift Logs</h2>
        </div>
        <div className="flex items-center gap-3">
          <input
            type="date"
            value={reportDate}
            onChange={(e) => setReportDate(e.target.value)}
            className="rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm"
          />
          <button onClick={() => fetchLogs(reportDate)} className="text-sm text-brand-500 hover:underline">Reload</button>
        </div>
      </div>

      {message && <div className="rounded-lg border border-rose-200 bg-rose-50 px-3 py-2 text-sm text-rose-700">{message}</div>}

      <Card extra="p-0 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-100 dark:divide-navy-700">
            <thead className="bg-gray-50 dark:bg-navy-800">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-500">Upload Ref</th>
                <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-500">Date</th>
                <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-500">Staff ID</th>
                <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-500">Name</th>
                <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-500">Contact</th>
                <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-500">Role</th>
                <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-500">Department</th>
                <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-500">Hours</th>
                <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-500">Required</th>
                {/* <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-500">Compliance</th> */}
                <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-500">SMS Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100 bg-white dark:divide-navy-700 dark:bg-navy-700">
              {loading ? (
                <tr><td colSpan={11} className="py-10 text-center text-sm text-gray-400">Loading…</td></tr>
              ) : logs.length === 0 ? (
                <tr><td colSpan={11} className="py-10 text-center text-sm text-gray-400">No records found.</td></tr>
              ) : (
                logs.map((r) => (
                  <tr key={r.id} className="hover:bg-gray-50 dark:hover:bg-navy-600">
                    <td className="px-4 py-3 text-sm text-gray-700">{r.upload_reference}</td>
                    <td className="px-4 py-3 text-sm text-gray-700">{r.report_date}</td>
                    <td className="px-4 py-3 text-sm text-gray-700">{r.staff_id}</td>
                    <td className="px-4 py-3 text-sm text-gray-700">{r.full_name}</td>
                    <td className="px-4 py-3 text-sm text-gray-700">{r.contact}</td>
                    <td className="px-4 py-3 text-sm text-gray-700">{r.role}</td>
                    <td className="px-4 py-3 text-sm text-gray-700">{r.department}</td>
                    <td className="px-4 py-3 text-sm text-gray-700">{r.hours_worked}</td>
                    <td className="px-4 py-3 text-sm text-gray-700">{r.required_hours}</td>
                    <td className="px-4 py-3 text-sm text-gray-700">{r.compliance_status}</td>
                    <td className="px-4 py-3 text-sm text-gray-700">{r.sms_status}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
};

export default ShiftLogs;
